module.exports = __webpack_public_path__ + "assets/d0250f63b148ccc99469ce43b2008a46.png";